import { ApiAddress } from '@/services/apis'
import request from '@/services/request'
import { UnitEntity, UnitSet } from './unitSet.model'

export function getUnitSetList(params): Promise<UnitSet[]> {
  return request.get(ApiAddress.UNIT_SETS, { params })
}

export function getUnitSet(params): Promise<UnitSet> {
  return request.get(ApiAddress.UNIT_SET, { params })
}

export function createUnitSet(params, body): Promise<UnitSet> {
  return request.post(ApiAddress.UNIT_SETS, body, { params })
}

export function updateUnitSet(params, body) {
  return request.put(ApiAddress.UNIT_SET, body, { params })
}

export function activeUnitSet(params) {
  return request.put(ApiAddress.UNIT_SET_ACTIVE, {}, { params })
}

export function deleteUnitSet(params) {
  return request.delete(ApiAddress.UNIT_SET, { params })
}

export function getUnitSetEntities(params): Promise<UnitEntity[]> {
  return request.get(ApiAddress.UNIT_SET_UNITS, { params })
}

export function createUnitSetEntity(params, body) {
  return request.post(ApiAddress.UNIT_SET_UNITS, body, { params })
}

export function updateUnitSetEntity(params, body) {
  return request.put(ApiAddress.UNIT_SET_UNIT, body, { params })
}

export function deleteUnitSetEntity(params) {
  return request.delete(ApiAddress.UNIT_SET_UNIT, { params })
}

export function getActiveUnitSet(params): Promise<UnitSet> {
  return request.get(ApiAddress.ACTIVED_UNIT_SET, { params })
}